import { Component, Inject, OnInit, inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { switchMap } from 'rxjs';
import { CopyComponentStructure } from 'src/app/maintenance-admin/state/components-structure.actions';
import { CopyMode } from 'src/app/maintenance-admin/models/components-structure-menu.model';
import { LoadAllDepartmentsForSelectedTenant } from 'src/app/department/state/department.actions';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import { LoadAllTenants } from 'src/app/tenant/state/tenant.action';
import { TenantState } from 'src/app/tenant/state/tenant.state';
import { ITenant } from 'src/app/tenant/models/tenant.model';
import { markControlsAsTouched } from '../../functions/mark-controls-as-touched';
import { IdName } from '../../models/id-name';
import { CopyComponentsStructureForm } from './copy-components-structure.form';

@Component({
  selector: 'app-copy-components-structure-modal',
  templateUrl: './copy-components-structure-modal.component.html',
  styleUrls: ['./copy-components-structure-modal.component.scss'],
  standalone: false,
})
export class CopyComponentsStructureModalComponent implements OnInit {
  private readonly injector = inject(Injector);

  private readonly tenantsFromStore = select(TenantState.allTenants);
  private readonly departmentsForTenant = select(
    TenantUserAccessState.getAllDepartmentsForSelectedTenantWithPause
  );

  form: CopyComponentsStructureForm;
  allTenants: ITenant[];
  allDepartments: IdName[];
  allCopyModes = [
    { id: CopyMode.FullTransfer, name: CopyMode.FullTransfer },
    { id: CopyMode.Template, name: CopyMode.Template },
  ];

  constructor(
    public dialogRef: MatDialogRef<CopyComponentsStructureModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      moduleNumber: number;
      id?: string;
    },
    private store: Store
  ) {
    this.form = new CopyComponentsStructureForm(this.data.id);
  }

  ngOnInit(): void {
    this.store
      .dispatch([new LoadAllTenants()])
      .pipe(switchMap(() => toObservable(this.tenantsFromStore, { injector: this.injector })))
      .subscribe((tenants) => {
        this.allTenants = tenants;
      });
  }

  onTargetTenantChange(): void {
    this.store
      .dispatch([new LoadAllDepartmentsForSelectedTenant(this.form.targetTenantId.value)])
      .pipe(switchMap(() => toObservable(this.departmentsForTenant, { injector: this.injector })))
      .subscribe((departments) => {
        this.form.targetDepartmentIds.setValue([]);
        this.allDepartments = departments;
      });
  }

  onCopyContentsChange(): void {
    if (!this.form.copyContents.value) {
      this.form.copyMode.setValue(null);
    } else {
      this.form.copyMode.setValue(CopyMode.Template);
    }
  }

  save(): void {
    markControlsAsTouched(this.form);

    if (!this.form.valid) {
      return;
    }

    this.store.dispatch(new CopyComponentStructure(this.form.value));
  }
}
